import React from 'react';
import CenterContent from './CenterContent';
import styles from './Hero.module.css';

const Hero: React.FC = () => {
  return (
    <div className={styles.hero}>
      <CenterContent />
    </div>
  );
};

export default Hero;
